import { alpha } from "@mui/material/styles";
import { type FC } from "react";
import { NavLink } from "react-router";

import * as Styled from "~/components/UI/CategoryChip/CategoryChip.styles";
import {
  bgColorByBaseCategory,
  colorByBaseCategory,
} from "~/constants/baseCategory";
import { ROUTES } from "~/constants/routing";
import { getInsightCategoryColor } from "~/feature/insights/constants";
import { type IInsightCategoryRef } from "~/feature/insights/types";
import { BaseCategory } from "~/types/baseCategory";

interface IInsightCategoryChipProps {
  category: IInsightCategoryRef;
}

export const InsightCategoryChip: FC<IInsightCategoryChipProps> = ({
  category,
}) => {
  const hex = getInsightCategoryColor(category.color);
  const isBaseCategory = category.slug in colorByBaseCategory;

  const categoryColor = isBaseCategory
    ? colorByBaseCategory[category.slug as BaseCategory]
    : hex;
  const categoryBgColor = isBaseCategory
    ? bgColorByBaseCategory[category.slug as BaseCategory]
    : alpha(hex, 0.15);

  return (
    <Styled.StyledBox sx={{ display: "inline-flex", width: "auto", flex: "0 0 auto", alignItems: "center" }}>
      <Styled.StyledChip
        label={category.name}
        component={NavLink}
        to={ROUTES.insightsCategory.createURL(category.slug)}
        $color={categoryColor}
        $bgColor={categoryBgColor}
        $insight
        size="small"
        variant="outlined"
      />
    </Styled.StyledBox>
  );
};
